import { combineReducers } from 'redux';
import activityPlan from './activity-plan';
import filterInfo from './filter-box';
import realTimeDataFilterInfo from './real-time-data-filter-box';
import userPortrait from './user-portrait';
import plantDataInfo from './plant-data';
import activityVsActivity from './activity-vs-activity';
import activitySquare from './activity-square';
import productData from './product-data';
import rightsInfo from './no-rights-page';
import realActivityPlan from './real-time-plan';
import realActivitySquare from './real-time-square';
import visibleActivityList from './select-activity';
import dataReport from './data-report';
import flowOutStatistics from './flow-outstatistics';
import analysisSearch from './analysis-search';

export default combineReducers({
  activityPlan,
  filterInfo,
  userPortrait,
  plantDataInfo,
  activitySquare,
  activityVsActivity,
  productData,
  rightsInfo,
  realActivityPlan,
  realActivitySquare,
  realTimeDataFilterInfo,
  visibleActivityList,
  dataReport,
  flowOutStatistics,
  analysisSearch,
});
